var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"toolbar"}}),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),(_vm.waitDialogVisible)?_c('wait-dialog'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }